/* eslint-disable react-hooks/exhaustive-deps */
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React, { useEffect, useRef, useState, } from 'react'

import Charts from './Charts'
import CustomCards from './CustomCards'
import { ENDPOINT } from '../../services/endPoints'
import { GridforCards } from '../../styles/customStyles/customStyles'
import dummyData from "./dummyData.json"
import useMasterApi from '../../services/useMasterApi'

const Dashboard = () => {
  const initialRender = useRef(true);
  const starting_Year = 2024;
  const [myYears, setMyYears] = useState(["all_data"]);
  useEffect(()=>{
    const date = new Date();
    const currentYear = date.getFullYear(); 
    const difference_in_years = currentYear - starting_Year;
    const years = Array.from({length: difference_in_years + 1}, (_, i) => starting_Year + i);
    setMyYears([...myYears, ...years]);
  }, []);

    const { getWithQueryParams, data, loading, error } = useMasterApi();
    const [selectedYear, setSelectedYear] = useState("all_data");
  
    useEffect(()=>{
        getWithQueryParams(ENDPOINT.DASHBOARD_DATA, {year: "all_data"})
    },[]);

    useEffect(() => {
      if (initialRender.current) {
        initialRender.current = false;
      } else if (selectedYear) {
        getWithQueryParams(ENDPOINT.DASHBOARD_DATA, {year: selectedYear})
      }
    }, [selectedYear]);

    const handleChange = (event) => {
      setSelectedYear(event.target.value);
    };
    const { Total_Foot_Screening_Tests, Total_Registered_Nurses, Total_Registered_Patients, Total_Tertiary_Facilities, Total_Diabetic_Retinopathy_Tests } = data;

   const card_data = [Total_Registered_Patients, Total_Registered_Nurses, Total_Tertiary_Facilities, Total_Diabetic_Retinopathy_Tests,  Total_Foot_Screening_Tests]

    const dashboardContainerStyle = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "2rem"
    }

    if (loading) {
      return <h1>Loading...</h1>;
    }

  return (
    <>
    <Box sx={{ width: "100% !important", mb: "1rem", display:"inline-flex", justifyContent: "flex-end" }}>
       <FormControl >
          <InputLabel id="demo-simple-select-label">Select Year</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedYear}
            sx={{ width: "250px", }}
            label="Select Year"
            onChange={handleChange}
          >
            {myYears.map((year) => (
              <MenuItem key={year} value={year}>
                {year ==="all_data" ? "All Data" : year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        </Box>
      <Box sx={dashboardContainerStyle}>
        <GridforCards>
          {dummyData.data.map((data, index) => (
            <CustomCards
              key={data.id}
              imgURL={data.url}
              title={data.title}
              total={card_data[index]}
            />
          ))}
        </GridforCards>
        {Object.keys(data).length > 0 && <Charts card_data={data} />}
      </Box>
    </>
  );
}

export default Dashboard